import React, { useState } from 'react';

import { Checkbox } from '@atlaskit/checkbox';
import Heading from '@atlaskit/heading';
import SectionMessage from '@atlaskit/section-message';
import { CreatableSelect } from '@atlaskit/select';
import TextField from '@atlaskit/textfield';

import { getFeatures, setFeatures } from 'src/lib/featureFlags';

import Field from 'src/views/components/Form/Field';

const prod = { label: 'prod (https://app.pagerduty.com)', value: 'https://app.pagerduty.com' };
const euprod = { label: 'euprod (https://app.eu.pagerduty.com)', value: 'https://app.eu.pagerduty.com' };
const stage = { label: 'stage (https://app.pd-staging.com)', value: 'https://app.pd-staging.com' };
const local = { label: 'local (http://127.0.0.1:4000)', value: 'http://127.0.0.1:4000' };
const defaultOptions = [prod, euprod, stage, local];

function save(val) {
  setFeatures({ jiraServiceLocationBaseUrl: val });
}

const JiraServiceLocationSelector = () => {
  const [value, setValue] = useState(() => {
    const { jiraServiceLocationBaseUrl } = getFeatures();
    if (!jiraServiceLocationBaseUrl) return window.location.origin === 'https://app.eu.pagerduty.com' ? euprod : prod;
    const someDefault = defaultOptions.find(x => x.value === jiraServiceLocationBaseUrl);
    if (someDefault) return someDefault;
    return {
      label: jiraServiceLocationBaseUrl,
      value: jiraServiceLocationBaseUrl
    };
  });

  const handleChange = (val) => {
    save(val && val.value);
    setValue(val);
  };

  const handleCreate = (label) => {
    const newOption = {
      label: label.trim(),
      value: label.trim()
    };
    setValue(newOption);
    save(newOption.value);
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Field label="Integration service URL" helperMessage="For PagerDuty internal usage only">
        <CreatableSelect
          isClearable
          onChange={handleChange}
          onCreateOption={handleCreate}
          options={defaultOptions}
          value={value}
        />
      </Field>
    </div>

  );
};

export default class FeatureFlags extends React.Component {
  state = {
    features: {}
  };

  componentDidMount() {
    this.setState({ features: getFeatures() });
  }

  onToggle = name => {
    setFeatures({ [name]: !this.state.features[name] });
    this.setState({ features: {
      ...this.state.features,
      [name]: !this.state.features[name]
    } });
  };

  onTextChange = event => {
    const name = event.target.name;
    const value = event.target.value.trim();
    setFeatures({ [name]: value });
    this.setState({ features: {
      ...this.state.features,
      [name]: value
    } });
  }

  render() {
    const {
      loginToStaging,
      loginToEu
    } = this.state.features;

    return (
      <div style={{ maxWidth: 700, margin: 'auto' }}>
        <header style={{ padding: 20 }}>
          <Heading size="medium">Feature toggles. Use for dev and early access only</Heading>
        </header>
        <div>
          <Checkbox
            isChecked={loginToStaging}
            label="Use Staging PD REST API for not logged-in user (logged-in will use session environment)"
            onChange={e => this.onToggle('loginToStaging')}
          />
          <Checkbox
            isChecked={loginToEu}
            label="Use EU PD REST API for not logged-in user (logged-in will use session environment)"
            onChange={e => this.onToggle('loginToEu')}
          />
          <JiraServiceLocationSelector/>
          <br/>
          <Field label="UI branch" helperMessage="load UI assets from custom branch for testing">
            <TextField autoComplete="off" name="uiBranch" value={this.state.features.uiBranch} onChange={this.onTextChange}/>
          </Field>
          <br/>
          <Field label="UI commit sha" helperMessage="load UI assets by commit sha for testing">
            <TextField autoComplete="off" name="uiSha" value={this.state.features.uiSha} onChange={this.onTextChange}/>
          </Field>
          <br/>
          <br/>
          <SectionMessage>
            Changes are saved automatically.<br/>
            Please reload UI pages to catch Feature flags changes
          </SectionMessage>
        </div>
      </div>
    );
  }
}
